import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Din import er næsten klar!',
      description: 'Klik på Fortsæt for at fuldføre importen',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Nogle data i din fil mangler eller har forkert format',
      description: 'Ret fejlene nedenfor, og upload filen igen, eller fortsæt for at ignorere ugyldige rækker/celler',
    },
    [ValidationStatus.Invalid]: {
      title: 'Den uploadede fil kan ikke behandles',
      description: 'Ret fejlene nedenfor, og prøv igen',
    },
  },
  sections: {
    heading_validation: {
      title: 'Uoverensstemmelse i kolonnenavne/rækkefølge fundet:',
      rules: {
        Exact: 'Kolonne #{{column}} skal være til stede og hedde præcis <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Følgende fejl blev fundet:',
      labels: {
        row: 'Række <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} række importeres',
        imported_rows_other: '{{count}} rækker importeres',
        ignored_rows_one: '{{count}} række ignoreres',
        ignored_rows_other: '{{count}} rækker ignoreres',
      },
      fields: {
        email: 'E-mail',
        phone_number: 'Telefonnummer',
        first_name: 'Fornavn',
        last_name: 'Efternavn',
        birthday: 'Fødselsdag',
      },
      rules: {
        Required: 'Feltet {{field}} er påkrævet. Rækken ignoreres',
        Email: 'Feltet {{field}} skal være en gyldig e-mailadresse. Rækken ignoreres',
        Phone: 'Feltet {{field}} skal være et telefonnummer i internationalt format. Feltet ignoreres',
        Date: 'Feltet {{field}} skal være en gyldig dato. Feltet ignoreres',
      },
    },
  },
  buttons: {
    back_to_upload: 'Tilbage til upload',
    proceed: 'Fortsæt',
  },
  toasts: {
    error: 'Noget gik galt, kontakt support',
  },
};
